import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Divider,
  CardContent,
  Table,
  TableCell,
  TableRow,
  TableContainer,
  TableBody,
  TableHead,
  TableFooter,
  Grid,
  Button,
  Box,
  Paper,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  NativeSelect,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { addZeroes } from "./../../../utils";

const columns = [
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
    description: "Position name",
  },
  {
    field: "cost_per_hire",
    headerName: "Cost per hire",
    flex: 1,
    headerAlign: "center",
    align: "center",
    type: "number",
    description: "Position cost per hire",
    renderCell: (params) => {
      if (params.row.cost_per_hire === null) {
        return null;
      } else {
        return `$${addZeroes(params.row.cost_per_hire)}`;
      }
    },
  },
  {
    field: "turnover_rate",
    headerName: "Turnover Rate",
    description: "Turnover Rate",
    type: "number",
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      if (params.row.turnover_rate === null) {
        return null;
      } else {
        return `${params.row.turnover_rate * 100}%`;
      }
    },
  },
  {
    field: "vacancies",
    headerName: "Vacancies",
    description: "Total Vacancies",
    type: "number",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "avg_time_to_hire",
    headerName: "Avg time to hire",
    description: "Average time to hire",
    type: "number",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "time_to_fill",
    headerName: "Time to fill",
    description: "Time to fill",
    type: "number",
    flex: 1,
    headerAlign: "center",
    align: "center",
    valueGetter: (params) => {
      if (params.row.time_to_fill === null) {
        return "no data";
      } else {
        return `${params.row.time_to_fill}`;
      }
    },
  },
];

export default function ClientTableOverview({ positions }) {
  useEffect(() => {}, []);

  return (
    <Card>
      <CardHeader title="Position Data " />
      <Divider />
      <CardContent>
        <div style={{ height: 300, width: "100%" }}>
          <DataGrid
            rows={positions}
            columns={columns}
            pageSize={20}
            rowsPerPageOptions={[20]}
            checkboxSelecheckboxSelection={false}
          />
        </div>
      </CardContent>
    </Card>
  );
}
